module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/create_demand.323e9c1e.svg";